import { cn } from '@/lib/cn'
import { fmtInt } from '@/lib/format'

/**
 * An on/off filter (design §6): `aria-pressed`, and when on — the cyan tint, the cyan line and
 * a ✓ glyph, so the state is never colour only (rule 21). The label stays neutral ink (neon text
 * only from 17 px, rule 18). The count uses tabular figures.
 */
export function FilterChip({
  pressed,
  onChange,
  children,
  count,
  disabled,
  describedBy,
}: {
  pressed: boolean
  onChange: (pressed: boolean) => void
  children: React.ReactNode
  count?: number
  disabled?: boolean
  describedBy?: string
}) {
  return (
    <button
      type="button"
      aria-pressed={pressed}
      aria-describedby={describedBy}
      disabled={disabled}
      onClick={() => onChange(!pressed)}
      className={cn(
        'inline-flex h-8 items-center gap-1.5 rounded-full border px-3 text-caption [@media(pointer:coarse)]:min-h-11',
        'transition-colors duration-micro disabled:pointer-events-none disabled:opacity-40',
        pressed
          ? 'border-cyan bg-cyan-soft text-ink-1'
          : 'border-hairline-strong bg-surface-3 text-ink-2 hover:text-ink-1',
      )}
    >
      {pressed && <span aria-hidden>✓</span>}
      {children}
      {count !== undefined && <span className="tnum text-ink-2">{fmtInt(count)}</span>}
    </button>
  )
}
